import { supabase } from '../lib/supabase';

const toCamelCase = (obj) => {
  if (!obj || typeof obj !== 'object') return obj;
  if (Array.isArray(obj)) return obj?.map(toCamelCase);
  return Object.keys(obj)?.reduce((acc, key) => {
    const camelKey = key?.replace(/_([a-z])/g, (_, letter) => letter?.toUpperCase());
    acc[camelKey] = toCamelCase(obj?.[key]);
    return acc;
  }, {});
};

export const inspectionTemplateService = {
  async getByCategory(category, companyId = null) {
    try {
      let query;
      if (companyId) {
        query = supabase
          ?.from('inspection_templates')
          ?.select('*')
          ?.eq('category', category)
          ?.or(`is_global.eq.true,company_id.eq.${companyId}`)
          ?.order('sort_order', { ascending: true });
      } else {
        query = supabase
          ?.from('inspection_templates')
          ?.select('*')
          ?.eq('category', category)
          ?.eq('is_global', true)
          ?.order('sort_order', { ascending: true });
      }
      const { data, error } = await query;
      if (error) { console.error('[inspectionTemplateService] Error:', error); return []; }
      return (data || [])?.map(toCamelCase);
    } catch (err) {
      console.error('[inspectionTemplateService] Failed:', err);
      return [];
    }
  },

  async getAllGrouped(companyId = null) {
    try {
      let query;
      if (companyId) {
        query = supabase?.from('inspection_templates')?.select('*')?.or(`is_global.eq.true,company_id.eq.${companyId}`)?.order('category')?.order('sort_order');
      } else {
        query = supabase?.from('inspection_templates')?.select('*')?.eq('is_global', true)?.order('category')?.order('sort_order');
      }
      const { data, error } = await query;
      if (error) { console.error('[inspectionTemplateService] Error:', error); return {}; }
      const grouped = {};
      (data || [])?.forEach(t => {
        if (!grouped?.[t?.category]) grouped[t.category] = [];
        grouped?.[t?.category]?.push(toCamelCase(t));
      });
      return grouped;
    } catch (err) {
      console.error('[inspectionTemplateService] Failed getAllGrouped:', err);
      return {};
    }
  },

  async create(companyId, templateData) {
    try {
      const { data, error } = await supabase
        ?.from('inspection_templates')
        ?.insert({
          company_id: companyId,
          category: templateData?.category,
          template_name: templateData?.templateName,
          condition_status: templateData?.conditionStatus || 'regular',
          findings_text: templateData?.findingsText || '',
          recommendations_text: templateData?.recommendationsText || '',
          parts_json: templateData?.partsJson || [],
          labor_json: templateData?.laborJson || [],
          is_global: false,
          sort_order: templateData?.sortOrder || 99
        })
        ?.select()
        ?.single();
      if (error) throw error;
      return toCamelCase(data);
    } catch (err) {
      console.error('[inspectionTemplateService] Failed to create:', err);
      throw err;
    }
  }
};
